import { ReactDatePickerCustomHeaderProps } from 'react-datepicker'
import { DateTime } from 'luxon'
import { faAngleLeft, faAngleRight } from '@fortawesome/pro-regular-svg-icons'
import { faCaretUp, faCaretDown } from '@fortawesome/pro-solid-svg-icons'
import { Text } from '../../atoms/text'
import { Button } from '../../atoms/button'
import { Icon } from '../../atoms/icon'
import { TypographyStyles } from '../../../utils/style-helpers'

interface IDatePickerHeaderProps {
  showYear: boolean
  toggleShowYear: () => void
  showMonthYearPicker?: boolean
  showYearPicker?: boolean
}

export const DatePickerHeader = ({
  showYear,
  toggleShowYear,
  date,
  decreaseYear,
  decreaseMonth,
  increaseYear,
  increaseMonth,
  showMonthYearPicker,
  showYearPicker,
}: ReactDatePickerCustomHeaderProps & IDatePickerHeaderProps) => {
  const dateFormat = showMonthYearPicker ? 'yyyy' : 'MMMM yyyy'
  const stepByYear = showYear || showMonthYearPicker

  return (
    <div className="flex">
      <div
        onClick={() => !showYearPicker && toggleShowYear()}
        className="flex flex-1 ml-4 cursor-pointer text-center items-center"
        role="presentation"
      >
        <Text variant={TypographyStyles.H2} className="flex items-center">
          {showYear
            ? 'Select Year'
            : DateTime.fromJSDate(date).toFormat(dateFormat)}
        </Text>

        {!showYearPicker && (
          <Icon
            icon={showYear ? faCaretUp : faCaretDown}
            className="cursor-pointer mr-2 ml-2 mb-1 mr-1"
            color="text-neutral-400"
          />
        )}
      </div>

      <Button
        iconLeft={faAngleLeft}
        iconLeftClassName="ml-2"
        onClick={stepByYear ? decreaseYear : decreaseMonth}
        className="!mr-2"
        variant="secondary"
        size="square"
      />

      <Button
        iconLeft={faAngleRight}
        iconLeftClassName="ml-2"
        onClick={stepByYear ? increaseYear : increaseMonth}
        variant="secondary"
        size="square"
      />
    </div>
  )
}
